/**
 * 排出事業者データ補完
 * 排出事業者モーダル
 */
import Vue from "vue";
import * as httpConst from "@/constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/emissions`

const getDefaultState = () => {
  return {}
}

const transferEmission = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 排出事業者一覧
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    /**
     * 排出事業者 初期情報取得
     * @param jwnet_manifest_id {Number} JWNETマニフェスト_ID
     */
    show ({ commit }, { jwnet_manifest_id } ) {
      const api_path = `${API_PATH}/${jwnet_manifest_id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 排出事業者 新規登録
     * @param jwnet_manifest_id {Number} JWNETマニフェスト_ID
     * @param params {Object} 排出事業者情報
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 排出事業者 更新
     * 一覧選択からの登録(更新)で使用
     * @param id {Number} 選択した対象のJWNETマニフェストID
     * @param params {Object}
     * @param params.emission_id {Number} 排出事業者_ID
     * @param params.reflect_ids {Array} 反映する
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.patch(`${API_PATH}/${id}`, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  }
}

export default transferEmission;
